

import React, { useEffect, useState, useCallback } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { actionPt, IAction } from '../../utils/action';
import IUser from '../../dtos/IUser';
import { useToast } from '../../hooks/Toast';
import api from '../../services/api';
import { getValidationErrorsMessage } from '../../utils/getValidationErrors';
import * as Yup from 'yup';
import Spinner from '../../components/Spiner';
import { Container, Title, SubTitle, Controle, TdAction, PaginationSpot } from './styles';
import ButtonIcon from '../../components/ButtonIcon';
import Pagination from '../../components/Pagination';
import Table from '../../components/Table';
import Main from '../../components/Main'
import { useAuth } from '../../hooks/Auth';



const RegisterUser: React.FC = () => {


    const { credential } = useAuth();

    const { addToast } = useToast();

    const { register: registerFilter, handleSubmit: handleSubmitfilter } = useForm();
    const { register: registerAction, handleSubmit: handleSubmitAction, setValue: setValueAction } = useForm();
    const { handleSubmit: handleSubmitRemove } = useForm();



    const [showModalFilter, setShowModalFilter] = useState(false);
    const [showModalAction, setShowModalAction] = useState(false);
    const [showModalRemove, setShowModalRemove] = useState(false);

    const [loading, setLoading] = useState(false)

    const [action, setAction] = useState<IAction>()
    const [users, setUsers] = useState<IUser[]>([])
    const [user, setUser] = useState<IUser>()
    const [dataPagination, setdataPagination] = useState<any[]>([])





    useEffect(() => {
        async function Load(): Promise<void> {
            setLoading(true)
            const response = await api.post('user-filter/', {})
            setUsers(response.data);
            setLoading(false)
        }
        Load()
    }, [])



    const handleSetForm = useCallback((item: IUser | undefined) => {
        setValueAction('id', item?.id)
        setValueAction('name', item?.name)
        setValueAction('email', item?.email)
        setValueAction('password', item?.password)
    }, [setValueAction])




    const handleShowModalFilter = useCallback(() => {
        setShowModalFilter(true)
    }, [])
    const handleHideModalFilter = useCallback(() => {
        setShowModalFilter(false)
    }, [])
    const handleShowModalAction = useCallback(() => {
        setShowModalAction(true)
    }, [])
    const handleHideModalAction = useCallback(() => {
        setShowModalAction(false)
    }, [])
    const handleShowModalRemove = useCallback(() => {
        setShowModalRemove(true)
    }, [])
    const handleHideModalRemove = useCallback(() => {
        setShowModalRemove(false)
    }, [])



    const handleChange = useCallback(
        async (data: IUser) => {

            if (!data || !users) {
                return
            }
            if (action === 'create') {
                setUsers([...users, data]);
            }
            if (action === 'update') {
                setUsers(
                    users.map(item => {
                        if (item.id === data.id) {
                            return data;
                        }
                        return item;
                    }),
                );
            }
            if (action === 'remove') {
                setUsers(users.filter(item => item.id !== data.id));
            }
        }, [users, action],
    );


    const handleAction = useCallback((actionHere: IAction, item: any | undefined) => {
        handleSetForm(item)
        setUser(item)
        setAction(actionHere)
        if (actionHere === 'remove') {
            handleShowModalRemove()
        } else {
            handleShowModalAction()
        }
    }, [handleShowModalAction, handleShowModalRemove, handleSetForm])


    const handleFilter = useCallback(async (data) => {

        setLoading(true)
        if (data.name_Filter === '') {
            data.name_Filter = undefined;
        }

        if (data.email_Filter === '') {
            data.email_Filter = undefined;
        }

        if (data.type_Filter === '') {
            data.type_Filter = undefined;
        }

        const response = await api.post('user-filter/', data)
        setUsers(response.data);
        setLoading(false)

        handleHideModalFilter()

    }, [handleHideModalFilter])


    const handleRemove = useCallback(async () => {
        try {
            const response = await api.delete(`/users/${user?.id}`);
            addToast({
                type: 'success',
                title: `item ${actionPt(action)}`,
            });

            handleChange(response?.data);
            setUser(undefined)
            handleHideModalRemove()
        } catch (err) {
            addToast({
                type: 'error',
                title: 'Erro no processamento do usuário',
                description: err.response.data.message,
            });

        }
    }, [user, action, addToast, handleChange, handleHideModalRemove])


    const handleModalAction = useCallback(
        async (data: IUser) => {

            try {
                const schema = Yup.object().shape({
                    name: Yup.string().required("Nome é obrigatório"),
                    email: Yup.string().required("Email é obrigatório"),
                    password: Yup.string().required("Senha é obrigatório"),
                });

                await schema.validate(data, {
                    abortEarly: false,
                });
                let response;
                switch (action) {
                    case 'create':
                        response = await api.post('/users', data);
                        break;
                    case 'update':
                        response = await api.put(`/users/${user?.id}`, data);
                        break;
                    default:
                        break;
                }

                addToast({
                    type: 'success',
                    title: `item ${actionPt(action)}`,
                });



                handleChange(response?.data);
                handleHideModalAction()
                setUser(undefined)
                handleSetForm(undefined)

            } catch (err) {
                if (err instanceof Yup.ValidationError) {
                    const errors = getValidationErrorsMessage(err);
                    addToast({
                        type: 'error',
                        title: 'Erro no preenchimento do usuário',
                        description: errors,
                    });
                    return;
                }
                addToast({
                    type: 'error',
                    title: 'Erro no processamento do usuário',
                    description: err.response.data.message,
                });
            }
        },
        [addToast, handleChange, action, user, handleHideModalAction, handleSetForm],
    );


    const handleLoadPagination = useCallback((data: any[]) => {
        setdataPagination(data);
    }, [])


    const handleCancelRemove = useCallback(()=>{
        handleHideModalRemove()
    },[handleHideModalRemove])

    return (


        <Main>
            <Container>
                <Title>Cadastro de Usuários</Title>
                <SubTitle>Seque a lista dos usuários cadastrados</SubTitle>
                <Controle>
                    <ButtonIcon
                        iconType="Create"
                        onClick={() => { handleAction('create', undefined) }}
                        title={credential.permissions === 'admin' ? 'Criar' : 'Você não tem permissão para era essa ação'}
                        disabled={credential.permissions === 'admin' ? false : true}
                    />
                    <ButtonIcon
                        iconType="Filter"
                        onClick={handleShowModalFilter}
                        title={credential.permissions === 'admin' ? 'Filtar' : 'Você não tem permissão para era essa ação'}
                        disabled={credential.permissions === 'admin' ? false : true}
                    />
                </Controle>

                <Table >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataPagination.map(item => (
                            < tr key={item.id}>
                                <td>{item.id} </td>
                                <td>{item.name} </td>
                                <td>{item.email} </td>
                                <TdAction>
                                    <ButtonIcon
                                        iconType="Update"
                                        onClick={() => { handleAction('update', item) }}
                                        title={credential.permissions === 'admin' ? 'Atualizar' : 'Você não tem permissão para era essa ação'}
                                        disabled={credential.permissions === 'admin' ? false : true}

                                    />
                                    <ButtonIcon
                                        iconType="Remove"
                                        onClick={() => { handleAction('remove', item) }}
                                        title={credential.permissions === 'admin' ? 'Remover' : 'Você não tem permissão para era essa ação'}
                                        disabled={credential.permissions === 'admin' ? false : true}
                                    />
                                </TdAction>
                            </tr>
                        ))}

                    </tbody>

                </Table>

                {loading && (<Spinner />)}

                <Modal size="lg" show={showModalFilter} onHide={handleHideModalFilter} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Selecione os filtros</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitfilter(handleFilter)}>
                            <Form.Group>
                                <Form.Label className="text-muted small"> Nome</Form.Label>
                                <Form.Control  {...registerFilter("name_Filter")} type="text" placeholder="Entre com o nome" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Email</Form.Label>
                                <Form.Control {...registerFilter("email_Filter")} type="text" placeholder="Entre com o email" />
                            </Form.Group>
                            <Button variant="success" type="submit" className="btn mb-4">Filtar</Button>
                        </Form>
                    </Modal.Body>
                </Modal>


                <Modal size="lg" show={showModalRemove} onHide={handleHideModalRemove} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirme a exclusão do registro</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitRemove(handleRemove)}>
                            <Form.Row>
                                <Form.Group className="mr-2" >
                                    <Button variant="success" type="submit" className="btn mb-4">Confirmar</Button>
                                </Form.Group>
                                <Form.Group  >
                                    <Button variant="dark"  onClick={handleCancelRemove} className="btn mb-4">Cancelar</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Modal.Body>
                </Modal>


                <Modal size="lg" show={showModalAction} onHide={handleHideModalAction} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{action === 'create' ? "Adicionar Registro" : "Atualizar Registro"}</Modal.Title>
                    </Modal.Header  >
                    <Modal.Body >
                        <Form onSubmit={handleSubmitAction(handleModalAction)}>
                            <Form.Group>
                                <Form.Label className="text-muted small"> Id</Form.Label>
                                <Form.Control disabled  {...registerAction("id")} type="number" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Nome</Form.Label>
                                <Form.Control  {...registerAction("name")} type="name" placeholder="Entre com o nome" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Email</Form.Label>
                                <Form.Control  {...registerAction("email")} type="email" placeholder="Entre com o email" />
                            </Form.Group>
                            <Form.Group >
                                <Form.Label className="text-muted small">Senha</Form.Label>
                                <Form.Control {...registerAction("password")} type="password" placeholder="Entre com a senha" />
                            </Form.Group>
                            <Button variant="success" type="submit" className="btn mb-4">Salvar</Button>
                        </Form>
                    </Modal.Body>
                </Modal>


                <PaginationSpot>
                    <Pagination data={users} handleLoadPagination={handleLoadPagination} />
                </PaginationSpot>


            </Container>
        </Main >




    );
};


export default RegisterUser;